import { render, staticRenderFns } from "./TocItem.vue?vue&type=template&id=3deff0ea&scoped=true"
import script from "./TocItem.vue?vue&type=script&lang=js"
export * from "./TocItem.vue?vue&type=script&lang=js"
import style0 from "./TocItem.vue?vue&type=style&index=0&id=3deff0ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3deff0ea",
  null
  
)

export default component.exports